import { useTranslation } from '@/i18n';

type TrackSection = 'status' | 'info';

type TrackSectionBarProps = {
  activeSection: TrackSection;
  onChange: (section: TrackSection) => void;
};

const SectionTab = ({
  isActive,
  label,
  onClick,
}: {
  isActive: boolean;
  label: string;
  onClick: () => void;
}) => (
  <button
    aria-selected={isActive}
    className='group px-1 py-2 transition-opacity hover:opacity-90'
    onClick={onClick}
    role='tab'
    type='button'
  >
    <span
      className={`relative inline-block pb-1 text-[13px] font-semibold uppercase tracking-[0.18em] transition-colors duration-300 sm:text-sm ${
        isActive ? 'text-backgroundGreen' : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      {label}
      <span
        aria-hidden
        className={`absolute bottom-0 left-0 right-0 h-[2px] origin-left rounded-full bg-greenSecondary transition-transform duration-300 ease-out ${
          isActive ? 'scale-x-100' : 'scale-x-0'
        }`}
      />
    </span>
  </button>
);

const TrackSectionBar = ({ activeSection, onChange }: TrackSectionBarProps) => {
  const { t } = useTranslation();

  const sections: Array<{ id: TrackSection; label: string }> = [
    { id: 'status', label: t('trackSection.status') },
    { id: 'info', label: t('trackSection.info') },
  ];

  return (
    <div className='flex items-center gap-5 sm:gap-6' role='tablist'>
      {sections.map(({ id, label }) => (
        <SectionTab
          key={id}
          isActive={activeSection === id}
          label={label}
          onClick={() => onChange(id)}
        />
      ))}
    </div>
  );
};

export type { TrackSection };
export { TrackSectionBar };
